<!-- 热门话题 -->
<template>
<div class="hot-subject">
    <div class="title"> <img :src="require('./assets/hot.png')" alt="" height="22"> 热门话题</div>
    <ul class="hot-list">
        <li v-for="(item,index) in list " :key="item.id">
            <a :href="'/discussion/'+item.id|hostBuild('topic')" target="_blank">
                <div class="top" v-if="item.top && index==0"><img :src="require('./assets/top.png')" height="15" alt=""></div>
                <div class="ico" v-else>#</div>
                <div class="name" :title="item.title">
                    {{item.title}}
                    <img v-if="item.hot" :src="require('./assets/fire.png')" alt="" height="16">
                    <span v-if="item.optimized" class="prize-tag">奖</span>
                </div>
            </a>
           
        </li>
    </ul>
</div>
</template>
<script>
export default {
    name:'HotSubject',
    data(){
        return {
            list:[],
        }
    },
    created(){
        this.getList();
    },
    methods:{
        async getList(){
            let result = await this.$axios.post('/subject/v1/subject/get/list/hot',{offset:1,size:10});
            console.log('热门话题--->',result)
            this.list = result.data.subjects;
        }
    }
}
</script>
<style lang="less" scoped>
.hot-subject{
    margin-bottom: 30px;
    .title{
        display: flex; align-items: center; margin-bottom: 20px;
        font-size: 20px; line-height: 28px; color: #111; font-weight: 500;
        img{margin-right: 10px; height: 22px;}
    }
    .hot-list{
        li{
            margin-bottom: 25px;
            a{
                 cursor: pointer;
                display: flex;  align-items: center;
                &:hover{color: #e43a3a;}
                .top{
                    margin-right: 10px;
                    img{height: 15px;}
                }
                .ico{display: inline-block; width:14px; line-height: 14px; font-size: 12px; color: #fff;background: #e43a3a; border-radius: 50%; margin-right: 10px; text-align: center;}
                .name{flex:1; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;
                    img{margin-left: 5px;}
                    .prize-tag{ font-size: 12px; line-height: 16px; width: 16px; display: inline-block; background: #e43a3a; border-radius: 4px; text-align: center; color: #fff; margin-left: 5px;}
                }
            }
            &:last-child{margin-bottom: 0;}
        }
    }
}
</style>